import Vue from 'vue'
import Vuex from 'vuex'
import request from '../utils/request';
import wxLogin from '../utils/wx-login.js'
import wxPay from '../utils/wx-pay.js'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import  router from '../router/index.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
		// 微信登录的token
		token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
		//token: localStorage.getItem('token') ? localStorage.getItem('token') : 'Nl_CKk-CRgujPNmR5f94S38xHPY2s0s7W3OoQTShPddQ-ORxzsOnZBEERC0iYvEpjliDKUSmvyT2OmgHDMNH63Q3np_JE0ofKMxh0JcOQyejBS_JVxWBmgPFSTQCtVuN',
		//设备id
		device_id:"2021WAP",
		//微信用户信息
		user:localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},
		//购物车商品列表
		cartList:[],
		//自提点列表
		branchs:[],
		groupList:{},//团购商品购物车角标数据
		cartTotalNum:'',//购物车总数量
		goBindPhone:false,
		bgImg:'',
		group_search:"",
  },
  mutations: {
	  setbgImg(state,data){
		  state.bgImg  =data.bg_img
	  },
	  setgroupSearch(state,data){
	  	state.group_search  =data.group_search
	  },
	  
     // 修改token，并将token存入localStorage
        setToken (state, userToken) {
		  state.token = userToken
          localStorage.setItem('token', userToken)
        },
	//清除token
		removeToken(state){
			state.token=null;
			state.groupList={};
			state.cartList=[];
			state.cartTotalNum = ''
			localStorage.removeItem('token')
			localStorage.removeItem('preRoute')
			localStorage.removeItem('isPreRoute')
		},
	//缓存微信用户信息
		setUserToken(state,user){
			state.user=user;
			localStorage.setItem('user', JSON.stringify(state.user))			
		},
	//清除微信用户信息Token
		removeUserToken(state,user){
			state.user={};
			localStorage.removeItem('user')
		},
	// 获取购物车列表
		cartGet(state,cartList){
			state.cartList=cartList
		},
	// 更改购物车商品
		modifyCart(state,product){
			state.cartList.map(item=>{
				let goods = item.item_list.find(i=>i.item_id == product.item_id)
				if(goods){
					goods.goods_num=product.goods_num
				}
			})		
		},
	// 删除购物车商品
		delCartItem(state,product){	
			state.cartList.map(item=>{
				let index = item.item_list.findIndex(i=>i.item_id == product.item_id)				
				if(index != -1){
					item.item_list.splice(index,1);
					Toast({
						message:"已删除",
						duration:500,
					})
				}
			})
		},
	//设置购物车数量
		
	setCartTotalNum(state,data){
		state.cartTotalNum = data
	},
	setGroupList(state,data){
		state.groupList = data
	},
	//获取自提点列表
	getBranchByLocation(state,data){
		state.branchs=data
	},
	//绑定手机号标识
	setBindPhone(state){
		state.goBindPhone = true
	},
	clearBindPhone(state){
		state.goBindPhone = false
	},
  },
  actions:{
	  getbaseConfig(context){
	  	return request.postURL('/api/activity/getBgImg',{				
	  	}).then((res)=>{
			let data = res.data.data
	  		context.commit('setbgImg',data)
			context.commit('setgroupSearch',data)
	  	})
	  },
	//获取购物车数量
	getItemNum(context){
		return request.postURL('/api/cart/getItemNum',{				
		}).then((res)=>{

			let list = res.data.data.group_list;//团购商品已加购数量
			context.commit('setGroupList',list)

			let sumNum = 0			
			Object.values(list).map(item=>{
				Object.values(item).map(i=>{					
					sumNum=sumNum+i
				})
			})
			context.commit('setCartTotalNum',sumNum)
		})
	},
	// 获取用户的信息	
	getUserAsync(context){
		return request.postURL('/api/user/getUserOwnInfo', {
		  }).then(function (res) {
			  var user=res.data.data
			  context.commit('setUserToken',user);
			  context.dispatch('cartGetAsync')
		  }).catch(function (err) {
			  console.log(err)
		  });
	},
	//加购物车
	addCartAsync(context,params){
		if(context.state.token){			
			if(!context.state.user.mobile){
				context.commit('clearBindPhone');
				Dialog.confirm({
				  title: '绑定手机号',
				  message: '您需要绑定手机号才能继续操作！',
				})
				  .then(() => {
				    router.replace('/userCenter')
				  })
				  .catch(() => {
				    // on cancel
				  });
				return
			}		
		}
		return request.postURL('/api/cart/addItem',{
			activity_id:params.activity_id,
			item_id:params.item_id,
			cart_source:'group',
		}).then(function(res){
			var id= res.data.data.activity_id	
			context.dispatch('cartGetAsync',id)
			Toast({
				message:"加购成功",
				duration:300,
			})
		}).catch(function (err) {
		   console.log(err)		   
		});	
	},
	//获取购物车商品
	cartGetAsync(context,id){
		return request.postURL('/api/cart/getItemList',{
			cart_source:'group',
			// activity_id:id
		}).then(function(res){
			const cartList=res.data.data 			
			context.commit('cartGet',cartList)//获取购物车列表
			context.dispatch('getItemNum')//获取购物车数量
		}).catch(function (err) {
		   console.log(err)
		  });
	},	
	//修改购物车数量
	modifyCartAsync(context,product){
		return request.postURL('/api/cart/modifyItem',{
			item_id:product.item_id,
			goods_num:product.goods_num,
			activity_id:product.activity_id,
			cart_source:'group',
		}).then(function(res){		
				context.commit('modifyCart',product);
				context.dispatch('getItemNum')//获取购物车数量
		}).catch(function (err) {
		   console.log(err)
		  });
	},
	//删除购物车商品
	delCartItemAsync(context,product){
			return request.postURL('/api/cart/deleteItemList',{
			id:product.id,
			item_id:product.item_id,
		}).then(function(res){
			context.dispatch('getItemNum')//获取购物车数量
			context.commit('delCartItem',product);
			
		}).catch(function (err) {
		   console.log(err)
		  });
	},
	// 用户提交订单接口
	actOrderAsync(context,params){
		return request.postURL('/api/order/submitOrder',{
			branch_id:params.branch_id, //门店id
			app_type:'group_h5',//应用类型
			gift_type:0,
			detail:params.detail,
			reduction_id:params.reduction_id,
			gift_item_id:params.gift_item_id
		}).then(function(res){
			if(res.data.code==1){
				let id=res.data.data.order_info.order_id
				context.dispatch('prePayOrder',id)
			}			
		}).catch(function(err){
			
		})
	},
	//订单支付预处理接口
	prePayOrder(context,id){
		const toast=Toast.loading({
		  message: '',
		  forbidClick: true,
		  loadingType: 'spinner',				  
		});
		return request.postURL('/api/order/prePayOrder',{
			id:id,
			pay_type:'wxpay',
			app_type:'group_h5',
		}).then(function(res){
			if(res.data.code==1){
				const params={
					appId:res.data.data.pay_info.appId,
					timeStamp:res.data.data.pay_info.timeStamp,
					nonceStr:res.data.data.pay_info.nonceStr,
					package:res.data.data.pay_info.package,
					paySign:res.data.data.pay_info.paySign,
					order_info:res.data.data.order_info
				}
				wxPay(params)				
			}else{
				console.log(res)
			}
			toast.clear()
		}).catch(function (err) {
				console.log(err)
				Dialog.alert({
				  message: err.data.msg,
				})
				  .then(() => {
					//支付失败后跳转到待支付订单页
					router.replace({
						path:'/orderList',
						query:{
							name:'待支付'
						}
					})
				  })
				  .catch(() => {
				    
				  });
		   toast.clear()
		  });
	},
	//获取自提点列表
	getBranchByLocationAsync(context,userlocation){
		const toast=Toast.loading({
		  message: '',
		  forbidClick: true,
		  loadingType: 'spinner',				  
		});
		return request.postURL('/api/item/getBranchByLocation',{
			longitude:userlocation.longitude,
			latitude:userlocation.latitude,
		}).then(function(res){
			let data = res.data.data
			context.commit('getBranchByLocation',data)
			toast.clear()
		}).catch(function (err) {
		   toast.clear()
		   console.log(err)
		  });
	},	
  }
})
export default store